export class HomeTabConstants {
    static readonly activeOrders: string = "one";
    static readonly orderHistory: string = "two";
    static readonly pendingOrders: string = "three";
    static readonly returns: string = "four";
}
